/* eslint-disable array-callback-return, consistent-return */

import React from 'react';
import PropTypes from 'prop-types';
import socialModel from './social_models';
import { popupCenter, trackSocial } from '../../../utils/share_util';
import { trainParselyProfile } from '../../../client/utils/third_party_trackers/parsely';
import withTracking from '../../../utils/tracking/components/withTracking';
import { defaultClick } from '../../../utils/tracking/events/pageEvents';
import EventModel from '../../../utils/tracking/models';
import get from 'lodash/get';
import RecircByTag from '../recirc_by_tag/recirc_by_tag';

function handleClick(event, url, popup, socialShare, props, index) {
  if (socialShare.action !== 'email') {
    event.preventDefault();
  }

  // [DataLayer] trigger nav item click event
  const clickEvent = new EventModel(
    'Post Social Click',
    `social${socialShare.platform}`,
    'postSocial',
    `social ${socialShare.platform}`,
    index + 1
  );

  props.trackClick(clickEvent.getTrackingObject());

  if (popup) {
    popupCenter(event, url, 560, 725);
  }

  if (socialShare) {
    trackSocial(socialShare.platform, socialShare.action);
    trainParselyProfile();
  }
}

function renderSocialList(empty, properties, props) {
  const overrideColor = get(props, 'overrideColor', '');
  return (
    <ul className={`social__list ${empty ? 'social__list--post-empty' : ''}`}>
      {properties.map((sharer, index) => {
        const { property, url, icon = '', popup, socialShare } = sharer;

        return (
          <li
            key={property}
            className={`social__item ${empty ? 'social__item--empty' : ''}`}
          >
            <a
              className={`social__link social__link--${property}`}
              href={url}
              onClick={e =>
                handleClick(e, url, popup, socialShare, props, index)
              }
              rel="noopener noreferrer"
            >
              <i
                style={overrideColor ? { color: `${overrideColor}` } : {}}
                className={`icon-${icon || property}`}
              />
            </a>
          </li>
        );
      })}
    </ul>
  );
}

function Social(props) {
  if (!props) {
    return null;
  }

  const encodedPostUrl = props.uri;
  const encodedTitle = props.text || props.socialText;
  const properties = socialModel(encodedPostUrl, encodedTitle, props.subject);
  const classes = ['social', `social--${props.modifier}`];

  const showRecirc = props.post.categories && props.post.categories[0];

  if (!props.active) {
    classes.push('social--hidden');
  }

  return (
    <div
      className={`${classes.join(' ')} ${showRecirc ? 'articleRecirc' : ''}`}
      id={props.encapsulateId}
      style={
        props.disableStyle
          ? {}
          : {
              position: props.enableSticky ? 'sticky' : 'initial',
              top: `${props.topValue}px`
            }
      }
    >
      {renderSocialList(props.empty, properties, props)}
      {showRecirc && <RecircByTag post={props.post} />}
    </div>
  );
}

Social.defaultProps = {
  uri: 'https://www.fastcompany.com',
  text:
    'Fast Company is the world&#x27;s leading progressive business media brand, with a unique editorial focus on innovation in technology, leadership, and design.',
  modifier: 'default',
  topValue: 100,
  subject: '',
  // bottomBoundary: 0,
  encapsulateId: '',
  empty: false,
  enableSticky: false,
  trackClick: PropTypes.func,
  socialText: {
    twitter: '',
    linkedin: '',
    email: ''
  },
  active: true,
  disableStyle: false,
  overrideColor: '',
  articleId: 0,
  tags: [],
  post: {}
};

Social.propTypes = {
  empty: PropTypes.bool,
  enableSticky: PropTypes.bool,
  modifier: PropTypes.string,
  uri: PropTypes.string,
  subject: PropTypes.string,
  text: PropTypes.string,
  disableStyle: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  socialText: PropTypes.shape({
    twitter: PropTypes.string,
    linkedin: PropTypes.string,
    email: PropTypes.string
  }),
  // bottomBoundary: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  encapsulateId: PropTypes.string,
  topValue: PropTypes.number,
  active: PropTypes.bool,
  // eslint-disable-next-line react/no-unused-prop-types
  overrideColor: PropTypes.string, // it is used, linter is being weird
  // eslint-disable-next-line react/no-unused-prop-types
  tags: PropTypes.oneOfType([PropTypes.array]),
  post: PropTypes.shape({
    categories: PropTypes.oneOfType([PropTypes.array])
  })
  // advertorial: PropTypes.bool
};

const mapTrackingToProps = trackEvent => ({
  trackClick: pageObject => trackEvent(defaultClick(pageObject))
});

const trackedSocial = withTracking(mapTrackingToProps)(Social);

export default trackedSocial;
